<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!supplier">
      <span class="loader"></span>
    </span>
    <supplier-form
      v-if="supplier"
      :loading="loading"
      :supplierData="supplier"
      :formErrors="formErrors"
      @supplierSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import SupplierForm from "../partials/SupplierForm.vue";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  layout: "DashboardLayout",

  components: { SupplierForm },

  mixins: [alertLeave, requestErrorMixin],

  props: {
    supplierId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      supplier: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("suppliers/get", this.supplierId);
        this.supplier = this.$store.getters["suppliers/supplier"];
        this.loading = false;
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    async handleSubmit(supplier) {
      this.loading = true;
      const supplierData = cloneDeep(supplier);

      try {
        await this.$store.dispatch("suppliers/update", supplierData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("SUPPLIERS.SUPPLIER_UPDATED"),
        });
        this.$emit("onViewSupplier", supplier, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
